import {
    USER_FORGOT_PASSWORD_SUCCESS,
    USER_FORGOT_PASSWORD_FAILURE,
    RESET_MESSAGE,
    USER_FORGOT_PASSWORD_REQUEST
} from "./constants";

const initialState = {
    emailSended: undefined
};

const forgetPasswordReducer = (state = initialState, action) => {

    switch (action.type) {
        case USER_FORGOT_PASSWORD_REQUEST: {
            return Object.assign( {}, state, {emailSended: undefined} );
        }
        case USER_FORGOT_PASSWORD_SUCCESS: {
            return Object.assign( {}, state, {emailSended: true} );
        }
        case USER_FORGOT_PASSWORD_FAILURE: {
            return Object.assign( {}, state, {emailSended: false} );
        }
        case RESET_MESSAGE: {
            return Object.assign( {}, state, {emailSended: undefined} );
        }
        default: {
            return state;
        }
    }
};

export default forgetPasswordReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/ForgetPassword/reducer.js